interface Props {
  saveChanges: () => void,
  publishDraft: () => void,
  deleteAction: () => void,
  hasUnsavedChanges: boolean
}

export const getDraftProductUpdateActions = ({ saveChanges, publishDraft, deleteAction, hasUnsavedChanges }: Props) => (
  [
    {
      isPrincipal: true,
      title: hasUnsavedChanges ? 'Save changes' : 'All saved',
      disabled: !hasUnsavedChanges,
      onClick: saveChanges,
      class: 'qa-save-draft'
    },
    {
      title: 'Publish Now',
      onClick: publishDraft,
      class: 'qa-publish'
    },
    {
      title: 'Delete',
      onClick: deleteAction,
      variant: 'danger',
      class: 'qa-delete-list-item'
    }
  ]
)
